import { Link } from 'react-router-dom'
import { useState } from 'react'
import logoImage from '../assets/images/BoxLogo.png'

export default function Logo({ 
  className = '', 
  showText = true, 
  linkTo = '/',
  size = 'md' // 'sm', 'md', 'lg'
}) {
  const [imageError, setImageError] = useState(false)

  const sizeClasses = {
    sm: 'h-6',
    md: 'h-8',
    lg: 'h-20'
  }

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl'
  }

  const boxSizeClasses = {
    sm: 'h-6 w-6 rounded',
    md: 'h-8 w-8 rounded-lg',
    lg: 'h-12 w-12 rounded-xl'
  }

  const showFallback = imageError

  const logoContent = (
    <>
      {!imageError && (
        <img 
          src={logoImage}
          alt="BoxHand Logo" 
          className={`${sizeClasses[size]} w-auto`}
          onError={() => {
            setImageError(true)
          }}
        />
      )}
      {showFallback && (
        <div className={`${boxSizeClasses[size]} bg-primary-600 flex items-center justify-center`}>
          <span className={`text-white font-bold ${size === 'sm' ? 'text-sm' : size === 'md' ? 'text-xl' : 'text-2xl'}`}>
            B
          </span>
        </div>
      )}
      {showText && (
        <h1 className={`ml-2 ${textSizeClasses[size]} font-bold text-gray-900 tracking-tight`}>
          BoxHand
        </h1>
      )}
    </>
  )

  if (linkTo) {
    return (
      <Link to={linkTo} className={`flex items-center ${className}`}>
        {logoContent}
      </Link>
    )
  }

  return (
    <div className={`flex items-center ${className}`}>
      {logoContent}
    </div>
  )
}

